define('geo/geo',["require", "exports", "./trig"], function (require, exports, trig_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.moveBearing = exports.fastDistancer = exports.fastDistance = exports.distance = exports.bearingr = exports.bearing = void 0;
    var R = 6371000; // earth radius in meters
    /**
     * Compute bearing from one point to another
     * @return bearing in degrees
     */
    function bearing(lat1, lng1, lat2, lng2) {
        var lat1r = (0, trig_1.toRadians)(lat1);
        var lat2r = (0, trig_1.toRadians)(lat2);
        // const latDelta = toRadians(lat2 - lat1)
        var lngDelta = (0, trig_1.toRadians)(lng2 - lng1);
        var y = Math.sin(lngDelta) * Math.cos(lat2r);
        var x = Math.cos(lat1r) * Math.sin(lat2r) - Math.sin(lat1r) * Math.cos(lat2r) * Math.cos(lngDelta);
        return (0, trig_1.toDegrees)(Math.atan2(y, x));
    }
    exports.bearing = bearing;
    /**
     * Compute bearing from one point to another
     * @input lat1, lng1, lat2, lng2 in radians
     * @return bearing in degrees
     */
    function bearingr(lat1, lng1, lat2, lng2) {
        // const latDelta = toRadians(lat2 - lat1)
        var lngDelta = lng2 - lng1;
        var y = Math.sin(lngDelta) * Math.cos(lat2);
        var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lngDelta);
        return Math.atan2(y, x);
    }
    exports.bearingr = bearingr;
    /**
     * Compute distance from one geographic point to another (2D)
     * @return distance in meters
     */
    function distance(lat1, lng1, lat2, lng2) {
        var lat1r = (0, trig_1.toRadians)(lat1);
        var lat2r = (0, trig_1.toRadians)(lat2);
        var latDelta = (0, trig_1.toRadians)(lat2 - lat1);
        var lngDelta = (0, trig_1.toRadians)(lng2 - lng1);
        var sinLat = Math.sin(latDelta / 2);
        var sinLng = Math.sin(lngDelta / 2);
        var a = sinLat * sinLat + Math.cos(lat1r) * Math.cos(lat2r) * sinLng * sinLng;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }
    exports.distance = distance;
    /**
     * Compute distance between two points using faster approximate distance computation
     * @return distance in meters
     */
    function fastDistance(lat1, lng1, lat2, lng2) {
        var lat1r = (0, trig_1.toRadians)(lat1);
        var lng1r = (0, trig_1.toRadians)(lng1);
        var lat2r = (0, trig_1.toRadians)(lat2);
        var lng2r = (0, trig_1.toRadians)(lng2);
        var x = (lng2r - lng1r) * Math.cos((lat1r + lat2r) * 0.5);
        var y = lat2r - lat1r;
        return R * Math.sqrt(x * x + y * y);
    }
    exports.fastDistance = fastDistance;
    /**
     * Compute distance between two points using faster approximate distance computation
     * @input lat1, lng1, lat2, lng2 in radians
     * @return distance in meters
     */
    function fastDistancer(lat1, lng1, lat2, lng2) {
        var x = (lng2 - lng1) * Math.cos((lat1 + lat2) * 0.5);
        var y = lat2 - lat1;
        return R * Math.sqrt(x * x + y * y);
    }
    exports.fastDistancer = fastDistancer;
    /**
     * Moves the location along a bearing (degrees) by a given distance (meters)
     */
    function moveBearing(lat_degrees, lng_degrees, bear_degrees, dist) {
        var d = dist / R;
        var lat = (0, trig_1.toRadians)(lat_degrees);
        var lng = (0, trig_1.toRadians)(lng_degrees);
        var bear = (0, trig_1.toRadians)(bear_degrees);
        // Precompute trig
        var sin_d = Math.sin(d);
        var cos_d = Math.cos(d);
        var sin_lat = Math.sin(lat);
        var cos_lat = Math.cos(lat);
        var sin_d_cos_lat = sin_d * cos_lat;
        var lat2 = Math.asin(sin_lat * cos_d + sin_d_cos_lat * Math.cos(bear));
        var lng2 = lng + Math.atan2(Math.sin(bear) * sin_d_cos_lat, cos_d - sin_lat * Math.sin(lat2));
        var lat3 = (0, trig_1.toDegrees)(lat2);
        var lng3 = (0, trig_1.mod360)((0, trig_1.toDegrees)(lng2));
        return { lat: lat3, lng: lng3 };
    }
    exports.moveBearing = moveBearing;
});
//# sourceMappingURL=/assets/javascripts/geo/geo.js.map;
